import type { EEntityType } from '@/service/personalWiki';

export enum ENoticeType {
  note = 'note',
  taskTodo = 'taskTodo',
  parseImage = 'parseImage',
  quickReply = 'quickReply',
  chat = 'chat',
  ctd = 'ctd',
  serendipity = 'serendipity',
  biog = 'biography_keyword_update',
  level = 'level',
  wiki = 'wiki',
  sessionInviteCreate = 'sessionInviteCreate',
  sessionInviteRespond = 'sessionInviteRespond',
  friendRequest = 'friend_request', //  收到好友请求的通知
  newFriend = 'new_friend', // 对方同意好友申请的通知
  sessionReceive = 'sessionReceive',
  talk = 'identityOut',
  taskFinish = 'taskFinish',
  autoReply = 'autoReply',
  softMemory = 'softMemory',
  duetSnapComplete = 'duetSnapComplete',
  circleJoin = 'circle_join',
  messageAction = 'messageAction'
}

export enum ENoticeNoteAction {
  add = 'add',
  edit = 'edit',
  revoke = 'revoke',
  shield = 'shield'
}

export enum ENoticeNoteStatus {
  success = 'success',
  fail = 'fail'
}

export interface ISourceCustom {
  index: number;
  parseId: string;
  content: string;
  end?: boolean; // 标识是否结束
}

export interface ISourceCustomForQuickReply {
  content: string;
}

export interface ISourceCustomForChatTitleUpdate {
  type: 'titleUpdate';
  sessionId: string;
  title: string;
}

export interface ISourceCustomForChatAdd {
  type: 'add';
  sessionId: string;
  bindMemoryType?: 'NOTE' | 'TODO';
  bindMemoryId?: number;
}

export interface ISourceCustomForLevel {
  level: number;
}

export interface ISourceCustomForWiki {
  entityType: EEntityType[];
}

export type ISourceCustomForBiog = string[];

export interface ISourceCustomForSessionInviteCreate {
  sessionId: string;
  userInfo: {
    userId: string;
    name: string;
    avatar: string;
    email: string;
  };
  uniqueKey: string;
}

export interface ISourceCustomForSessionInviteRespond {
  inviteRespond: 'ACCEPTED' | 'REJECTED';
  sessionId: string;
}

export interface IRouteParam {
  route: string;
}

export interface ISourceCustomFriendRequest {
  inviteRespond: 'INVITING' | 'ACCEPTED' | 'REJECTED';
  responseUserId: string;
  sessionId: string;
  userId?: string;
  routeParam?: IRouteParam;
}

export interface IFriendMessageReceive {
  message: string;
  sendTime: number;
  sessionId: string;
}

export interface IAutoReply {
  autoReply: boolean;
  sessionId: string;
  userId: string;
}

export interface ISourceCustomTalk {
  id: string;
}

export interface ISourceCustomSnap {
  id: string;
  sessionId: string;
}

export interface ISourceCustomSoftMemory {
  createTime: string;
  dataId: string;
  dataType: string;
  factActor: string;
  factContent: string;
  factObject: string;
  id: string;
  messageId: string;
  seqId: string;
  sessionId: string;
}

export interface ISourceCustomMessageAction {
  sessionId: string;
  messageId: string;
  sender: string;
  sendUserId: string;
  sourceAction: 'revoke' | 'shield';
}

// export type TNotice = INoticeNote | INoticeTodoList | IParseImage;

export type TNotice = {
  sourceType: ENoticeType;
  sourceAction: ENoticeNoteAction;
  sourceStatus?: ENoticeNoteStatus;
  sourceId: string;
  sourceCustom:
    | ISourceCustom
    | ISourceCustomForQuickReply
    | ISourceCustomForChatTitleUpdate
    | ISourceCustomForChatAdd
    | ISourceCustomForBiog
    | ISourceCustomForLevel
    | ISourceCustomForWiki
    | ISourceCustomForSessionInviteCreate
    | ISourceCustomForSessionInviteRespond
    | ISourceCustomFriendRequest
    | IFriendMessageReceive
    | IAutoReply
    | ISourceCustomSoftMemory
    | ISourceCustomTalk
    | ISourceCustomSnap
    | ISourceCustomMessageAction
    | {
        [key: string]: any;
      };
};
